import type {TypedSchema} from 'schemaDefinition/types';
import type {AgentWorkSummary} from 'services/agent/types';
import {workSummarySchema} from './workSummarySchema';

/**
 * Work schema extended with parts from expression and manifestation,
 * .i.e. mainTitles
 */
export const agentWorkSummarySchema: TypedSchema<AgentWorkSummary> = {
  name: 'agentWorkSummary',
  parts: [
    ...workSummarySchema.parts,
    {
      type: 'codelist',
      name: 'roles',
      cardinality: 'multiple',
      codelistId: 'WORK_AND_EXPRESSION_ROLE_TYPE',
    },
  ],
};
